// @flow

import React, { Component } from "react";
import {
  Form,
  FormControl,
  FormGroup,
  Col,
  ControlLabel,
  Button
} from "react-bootstrap";

import "./EmailPasswordForm.css";

type Props = {
  onSubmit: (data: {
    email: string,
    password: string
  }) => void,
  submitButtonLabel: string
};

type State = {
  email: string,
  password: string
};

class EmailPasswordForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: "",
      password: ""
    };
  }

  render() {
    return (
      <div className="EmailPasswordForm">
        <Form
          horizontal
          action=""
          onSubmit={event => {
            this.props.onSubmit(this.state);
            event.preventDefault();
          }}
        >
          <FormGroup controlId="formHorizontalEmail">
            <Col componentClass={ControlLabel} sm={2}>
              Email
            </Col>
            <Col sm={10}>
              <FormControl
                autoFocus
                type="email"
                placeholder="Email"
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalPassword">
            <Col componentClass={ControlLabel} sm={2}>
              Password
            </Col>
            <Col sm={10}>
              <FormControl
                type="password"
                placeholder="Password"
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col smOffset={2} sm={10}>
              <Button type="submit">{this.props.submitButtonLabel}</Button>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default EmailPasswordForm;



// WEBPACK FOOTER //
// ./src/components/EmailPasswordForm/EmailPasswordForm.js